import React, { useEffect, useState } from "react";
/*import { Route, Routes } from "react-router-dom";*/
import NumericCheckbox from "./NumericCheckbox"; 
import SideNavBar from "../Dashboard/mainnav";
//import { Report } from "./Pages/Report";
//import { Changepassword } from "./Pages/Changepassword";
//import { Logout } from "./Pages/Logout";
import "./Stocklist.css";
import CustomerDetails from "./Customerdetails";
import validatePhoneNumber from "./PhoneNumberValidation"
/*import DropOff from "./dropOff"*/
import MyModal from "./Modal" 
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
            
const Stockview = () => {
    const [stocklists, setStocklist] = useState([]);
    const [groupedDescriptions, setGroupedDescriptions] = useState({});
    const [activeGroup, setActiveGroup] = useState(null);
    const [dropOffType, setDropOffType] = useState("");
    const [reportID, setReportID] = useState("");
    const navigate = useNavigate(); 
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
    const history = useNavigate();
    const [customerDetails, setCustomerDetails] = useState({
        companyName: "",
        tel: "",
        contactPerson: "",
        address: "",
        refNo: "",
        dropOffType: "",
        date: new Date().toISOString(), // Set default date to today
        incident: ""
    });
    const [selectedItems, setSelectedItems] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState("");
    const [photoFile, setPhotoFile] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [demoAppInstalled, setDemoAppInstalled] = useState(null);
    const [captureResetKey, setCaptureResetKey] = useState(0);

    const handleLocationCaptured = (lat, lng) => {
        setLatitude(lat);
        setLongitude(lng);
    };
    
  
    const handleValueChange = (group, descriptionIndex, newValue) => {
        const updatedGroupedDescriptions = { ...groupedDescriptions };
        updatedGroupedDescriptions[group][descriptionIndex].value = newValue;
        setGroupedDescriptions(updatedGroupedDescriptions);

        // Get the selected item
        const selectedDescription = groupedDescriptions[group][descriptionIndex];
        const selectedStock = stocklists.find(stock => stock.description === selectedDescription.Description); // Find the corresponding stocklist item
        const selectedItem = {
            Description: selectedDescription.Description,
            stockListId: selectedStock ? selectedStock.stockListId : undefined, // Include stockListId if found, otherwise undefined
            quantity: newValue
        };

        // Check if the selected item is already in the array
        const index = selectedItems.findIndex(item => item.Description === selectedItem.Description);

        if (index !== -1) {
            // If the item is already in the array, update its quantity
            const updatedSelectedItems = [...selectedItems];
            updatedSelectedItems[index].quantity = newValue;
            setSelectedItems(updatedSelectedItems);
        } else {
            // If the item is not in the array, add it
            setSelectedItems(prevItems => [...prevItems, selectedItem]);
        }
    };


    useEffect(() => {
        // fetching code from the API
        fetch(`${BASE_URL}api/stocklist/GetallStock`)
            .then((response) => response.json())
            .then((responseJson) => {
                setStocklist(responseJson);
            })
            .catch((error) => {
            });
    }, []);

    useEffect(() => {
        const groupDescriptions = () => {
            const groupedItems = {};

            stocklists.forEach((item) => {
                const { description, stockGroup } = item;

                if (!groupedItems[stockGroup]) {
                    groupedItems[stockGroup] = [{ Description: description, value: 0 }];
                } else {
                    groupedItems[stockGroup].push({ Description: description, value: 0 });
                }
            });

            setGroupedDescriptions(groupedItems);
        };

        if (Array.isArray(stocklists) && stocklists.length > 0) {
            groupDescriptions();
        }
    }, [stocklists]);
     

    // Toggle active group to show/hide descriptions
    const toggleGroup = (group) => {
        setActiveGroup(activeGroup === group ? null : group);
    };


    const handleTelChange = (e) => {
        const newTelValue = e.target.value;

        const callback = (isValid) => {
            setIsPhoneNumberValid(isValid);
        };

        validatePhoneNumber(newTelValue, callback);

        setCustomerDetails({
            ...customerDetails,
            tel: newTelValue,
        });
    };



    // this one checks if stocklist is an array before rendering
    if (!Array.isArray(stocklists) || stocklists.length === 0) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    // this is the function to check if the form is valid
    const isFormValid = () => {
        // Implement your validation logic here
        // For now, we'll assume it's valid if all customer details are filled
        return (
            customerDetails.companyName !== "" &&
            customerDetails.tel !== "" &&
            customerDetails.contactPerson !== "" &&
            customerDetails.address !== ""
        );
    };


    // this is the function to handle "Next" button click
    const handleNextButtonClick = () => {
        if (isFormValid()) {
            // Implement navigation logic or desired action
        }
    };
    const handleFinishButtonClick = () => {
        if (isFormValid()) {
            setShowModal(true); // Show the modal
        }
    };
   
  
    const handleConfirmButtonClick = () => { 
            
            if (isFormValid()) {
                const stockData = selectedItems.map(item => [item.stockListId, item.quantity]);

                submitDropOffData(stockData);
            }
    };

        const submitDropOffData = (stockData) => {
            const formData = new FormData();
            formData.append('companyName', customerDetails.companyName);
            formData.append('tel', customerDetails.tel);
            formData.append('contactPerson', customerDetails.contactPerson);
            formData.append('address', customerDetails.address);
            formData.append('refNo', customerDetails.refNo);
            formData.append('dropOffType', dropOffType);
            formData.append('date', customerDetails.date);
            formData.append('incident', customerDetails.incident || '');
            formData.append('incidentType', customerDetails.incidentType || '');
            stockData.forEach((pair, index) => {
                formData.append(`stockData[${index}][0]`, pair[0]);
                formData.append(`stockData[${index}][1]`, pair[1]);
            });
            if (latitude != null) formData.append('Latitude', latitude);
            if (longitude != null) formData.append('Longitude', longitude);
            if (demoAppInstalled != null) formData.append('DemoAppInstalled', demoAppInstalled);
            if (photoFile) formData.append('Photo', photoFile);

            fetch(`${BASE_URL}api/StockTransactions/PostDropOff`, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Failed to submit data to the backend');
                    }
                    return response.text();
                })
                .then(data => {

                    if(data == 0){

                        setCustomerDetails({
                            companyName: "",
                            tel: "",
                            contactPerson: "",
                            address: "",
                            refNo: "",
                            dropOffType: "",
                            date: new Date().toISOString(),
                            incident: ""
                        });
                        setDropOffType("");
                        setPhotoFile(null);
                        setLatitude(null);
                        setLongitude(null);
                        setDemoAppInstalled(null);
                        setCaptureResetKey(key => key + 1);

                        navigate("/stocklist");

                    }else{

                        const reportID = data;

                        // Set the reportID using the state setter function
                        setReportID(reportID);
                        navigate(`/report/${reportID}`);
                    }
                    
                    
                })
                .catch(error => {
                });

    };

    return (
        <div className="black-background">
            <div className="container">
                <CustomerDetails
                    customerDetails={customerDetails}
                    handleTelChange={handleTelChange}
                    isPhoneNumberValid={isPhoneNumberValid}
                    handleNextButtonClick={handleNextButtonClick}
                    dropOffType={dropOffType}
                    setCustomerDetails={setCustomerDetails}
                    setDropOffType={setDropOffType}
                    isFormValid={isFormValid}
                    showIncidentHistory={false}
                    demoAppInstalled={demoAppInstalled}
                    onDemoAppInstalledChange={setDemoAppInstalled}
                    onPhotoSelected={setPhotoFile}
                    onLocationCaptured={handleLocationCaptured}
                    resetKey={captureResetKey}
                />

                <div className="accordion" id="descriptionAccordion">
                    <h3> Select Books</h3>
                    {Object.keys(groupedDescriptions).map((group) => (
                        <div className="accordion-item" key={group}>
                            <h2 className="accordion-header" id={`heading${group}`}>
                                <button
                                    className="accordion-button"
                                    type="button"
                                    onClick={() => toggleGroup(group)}
                                >
                                    <strong>Stock Group: {group}</strong>
                                </button>
                            </h2>
                            {activeGroup === group && (
                                <div
                                    className="accordion-collapse collapse show"
                                    aria-labelledby={`heading${group}`}
                                >
                                    <div className="accordion-body">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Description</th>
                                                    {/* Remove checkbox-related th */}
                                                    <th>Quantity</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {groupedDescriptions[group].map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.Description}</td>
                                                        {/* Remove checkbox-related td */}
                                                        <td>
                                                            <NumericCheckbox
                                                                className="numeric-checkbox"
                                                                value={item.value}
                                                                onValueChange={(newValue) =>
                                                                    handleValueChange(group, index, newValue)

                                                                }
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <div className="text-center mt-4">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleFinishButtonClick}
                        disabled={!isFormValid()}
                    >
                        Finish
                    </button>
                </div>
                <MyModal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    title="Drop-Off Confirmation"
                    body="Are you sure you want to drop off these items?"
                    selectedItems={selectedItems}
                    customerDetails={customerDetails}
                    reportID={reportID}
                    onConfirm={handleConfirmButtonClick}
                    photoFile={photoFile}
                    latitude={latitude}
                    longitude={longitude}
                    demoAppInstalled={demoAppInstalled}
                />
            </div>
        </div>
    );
};
export default Stockview;